import { render, staticRenderFns } from "./buff.vue?vue&type=template&id=6e85509f&"
import script from "./buff.vue?vue&type=script&lang=js&"
export * from "./buff.vue?vue&type=script&lang=js&"
import style0 from "./buff.vue?vue&type=style&index=0&id=6e85509f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports